import React, { Component } from 'react'
import './AboutUs.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import cardImg1 from '../../assets/images/cutomize-T-shirt-1.png';

import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

class AboutUs extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">About Us</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="elementor-widget-container">
                        <h2 className="elementor-heading-title elementor-size-default hdn1">
                            About Us
                        </h2>
                    </div>

                    <div className="row card1">
                        <div className="col-sm-6">
                            <div className="card crd">
                                <div className="card-body">
                                    <h3 className="card-title ttl">Who are we</h3>
                                    <p className="card-text txt">StyleCabbie is a “Made-in-India” business addressing the market of personalized goods to the masses offered in a creative e-tailing environment. 
                                    It’s been incubated by creative Indian minds with over 50 years of collective global business building experience in North America. 
                                    StyleCabbie offers apparels for women, men and children with a level of unparalleled customization.</p>

                                    <h3 className="card-title ttl">Our purpose</h3>
                                    <p className="card-text txt">We want our customers to be happy, smiling, satisfied presenting themselves to the world, “their-way”. 
                                    We cherish the opportunity to serve our customers. #BeYourself , #ProudStyler,  #ShareStyleIdeas,  #StyleCabbiePromoters</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 img1">
                            <div className="card rds">
                                <div className="card-body">
                                    <img src={cardImg1} alt="CardImg" />
                                </div>
                            </div>
                            <div className="card rds">
                                <div className="card-body">
                                    <img src={cardImg1} alt="Card Img" />
                                </div>
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="card">
                                
                            </div>
                        </div> */}
                    </div>
                </main>

                <Footer />

            </React.Fragment>
        )
    }
}
export default  AboutUs 
